import { z } from 'zod';

import type { Facet } from '@jane/bloom/types/facet';

export enum SortOptions {
  alphabetical = 'alphabetical',
  featured = 'featured',
  price = 'price',
  priceDesc = 'priceDesc',
  rating = 'rating',
  recommended = 'recommended',
  thcAsc = 'thcAsc',
  thcDesc = 'thcDesc',
}

export const SortOptionsSchema = z.enum(SortOptions);

export enum MenuProductSortSuffix {
  Alphabetical = '',
  Default = '', // eslint-disable-line @typescript-eslint/no-duplicate-enum-values
  Featured = '', // eslint-disable-line @typescript-eslint/no-duplicate-enum-values
  Price = 'by-price-',
  PriceDesc = 'by-price-desc-',
  Rating = 'by-rating-',
  Recommended = 'by-recommendation-ordinal-asc-',
  ThcAsc = 'by-thc-potency-asc-',
  ThcDesc = 'by-thc-potency-desc-',
}

export type AlgoliaProductFacets = {
  activities?: Facet;
  aggregate_rating?: Facet;
  applicable_brand_special_ids?: Facet;
  applicable_bulk_special_ids?: Facet;
  applicable_bundle_special_ids?: Facet;
  'applicable_bundle_special_ids.discount'?: Facet;
  'applicable_bundle_special_ids.qualify'?: Facet;
  applicable_cart_total_special_ids?: Facet;
  applicable_special_ids?: Facet;
  available_weights?: Facet;
  brand?: Facet;
  brand_subtype?: Facet;
  bucket_price?: Facet;
  category?: Facet;
  feelings?: Facet;
  has_brand_discount?: Facet;
  kind?: Facet;
  percent_cbd?: Facet;
  percent_thc?: Facet;
  root_types?: Facet;
};
